import {useHistory} from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import SearchIcon from '@material-ui/icons/Search';
import {makeStyles} from '@material-ui/core/styles';
import { Box, Card, CardContent, FormControl, FormControlLabel,
    Grid, IconButton, InputLabel, Radio,  Select,
    TextField, Tooltip, Typography, LinearProgress, 
    Button} from '@material-ui/core'
import TablaOrden from './TablaOrden';
 
import moment from 'moment';
import axios from 'axios';
import qs from 'qs';
import {ErrorGeneral, llamadaApiToken, llamaApiCargaToken} from '../funciones/ClienteAxios';
import RepoTab from "./RepoTab.js";
import React, {useContext, useEffect, useState} from "react";
import TablaBitacora from "./TablaBitacora.jsx";
import ReplayIcon from '@material-ui/icons/Replay';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'; 
const useStyles = makeStyles((theme) => ({
    title2: {
        fontSize: 18,
    },
    subTitle2: {
        fontSize: 12,
    },
    altura2: {
        minHeight: 70,
        marginTop: 0,
        paddingTop: 0,
    },
    altura3: {
        minHeight: 145,
        marginTop: 0,
        paddingTop: 0,
    },

}));


const Bitacora = () => {
    let history = useHistory();
    const classes = useStyles();
    const idusu = localStorage.getItem('UsuId');
    const source = axios.CancelToken.source();
    const colBase = process.env.REACT_APP_COLOR
    const {usuario, guardarUsuario} = useContext(AuthContext);
    const {guardarGenerales} = useContext(GeneralesContext);
    const [listBit, setListBit] = useState([])
    const [listStatus, setListStatus] = useState([])
    const [opcionStatus, setOpcionStatus] = useState(-1)
    const [ordenBusq, setOrdenBusq] = useState({orden: '', turno: ''});
    //const [fechasSeleccionadas, setFechasSeleccionadas] = useState({inicio: new Date(), final: new Date()});
    const {orden, turno} = ordenBusq;
    const [estatus, setEstatus] = useState(-2);
    const [buscar, setBuscar] = useState(true);
    const [regisMaquinaria, setRegistroMaquinaria] = useState([]);
    const [terminal, setTerminal] = useState([]);
    const [listMaquinaria, setListMaquinaria] = useState([])
    const [listMaquinariaOrig, setListMaquinariaOrig] = useState([])
    const [modalAbierto, setModalAbierto] = useState(false);
    const [esperaTabBit, setEsperaTabBit] = useState(false);
    const [espera, setEspera] = useState(false);
    const [filtro,setFiltro] = useState({supervisa:false})
    const [filtroSerie,setFiltroSerie] = useState("")
    const [filtroNoEco,setFiltroNoEco] = useState("")
    const [filtroDescr,setFiltroDescr] = useState("")
    

    useEffect(() => {                       

        const veriSesion = () => {
            const usu = localStorage.getItem('UsuarioNom');
            const nvl = localStorage.getItem('Tipo');
            if (usu === null) {
                guardarUsuario([])
                guardarGenerales([])
                localStorage.clear();
                history.push("/")
            } else {
                if (usuario.length === 0) {
                    guardarUsuario({Nombre: usu, nivel: nvl});
                }

                guardarGenerales({Titulo: 'Bitácora de Maquinas'})
                getListStatus()            
            }
        }
        veriSesion();
        return () => {
            source.cancel();
        }
    }, []);

    useEffect(()=>{
        getListMaquinaria() 
        setRegistroMaquinaria([])
    },[buscar])
 

    const getListMaquinaria = () => {
        const data = qs.stringify({
            Usuario: idusu,
            ip: "127.0.0.0",
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/maquinaria";

        function respuestaListTermin(aux) {
            if (aux[0].Id !== -1) {                
                setListMaquinaria(aux)
                setListMaquinariaOrig(aux)
            }
        }

        llamaApiCargaToken(data, url, respuestaListTermin, ErrorGeneral, setEspera, history, source)
    };    

    const getListStatus= () => {
        const data = qs.stringify({
          Usuario:idusu,          
          ip:"172.0.0.0",
          idDispositivo: '987gyubjhkkjh'
        });
        const url = "/maquinaria/status";
    
        function respuesta(aux) {
          if (aux[0].Id!==-1) 
          {                  
            setListStatus(aux);                                      
          }         
        }
        llamadaApiToken(data, url,respuesta,ErrorGeneral, history,source);
    };  

    const getListTabla = (Maquinaria) => {        
        
        const data = qs.stringify({
            Usuario:idusu,
            Maquinaria: Maquinaria,
            ip:"172.2.2.2",
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/maquinaria/bitacora";

        function respuestaListTabla(aux) {
            if (aux[0].Id !== -1) {
                setListBit(aux)
                
            } 
        }

        llamaApiCargaToken(data, url, respuestaListTabla, ErrorGeneral, setEsperaTabBit, history, source);
    };    

    const onChange = e => {
        let expNopermitida = new RegExp('[#._:$!%({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            setFiltroNoEco( e.target.value.trim()
            )
        }

    };

    const onChange2 = e => {
        let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMenos.test(e.target.value) && !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            
            setFiltroSerie( e.target.value.trim())
            
        }

    };

    const onChange3 = e => {
        let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMenos.test(e.target.value) && !expMas.test(e.target.value)) || e.target.value === ' ' || e.target.value === '') {
            
            setFiltroDescr( e.target.value.trim())
            
        }

    };
    const incrementarBuscar = e => {
        setBuscar(!buscar)
    };

    const onChangeTerminal = (event) => {
        setTerminal(event.target.value);
    };


   
    const filtroStatus=(valor)=>{
        const enteroVal= parseInt(valor)
        if (enteroVal=== -1) {
            setListMaquinaria(listMaquinariaOrig)
        }
        else{
            const auxFiltro = listMaquinariaOrig.filter((maqui)=>maqui.StId ===enteroVal)
            
            setListMaquinaria(auxFiltro)            
        }
        setRegistroMaquinaria([])
        //console.log(enteroVal);
        
        setOpcionStatus(enteroVal)
    }

    const Encabezado = ({espacio, estiloCampo, descripcion, campo}) => {
        return (
        <Box {...espacio} >
            <Typography className={classes.title2} variant="h5" color="secondary"
                component="h2" align="center" style={estiloCampo}
            >
                {campo}
            </Typography>
            <Typography className={classes.subTitle2} color="textSecondary" align="center">
                {descripcion}
            </Typography>
        </Box>
        )
    }

    const CampoRenglon = ({estiloBox, estiloTitulo, titulo, campo}) => {
        return (
            <Box  {...estiloBox} >
                <span style={estiloTitulo}>{titulo} </span>
                <Typography variant='body'> {campo}  </Typography>
            </Box>
        )
    }

    const costadoDerecho = (orden) => {
        let fecha = moment.utc(orden.fecha);
        let modificada = fecha.local(true).format("DD/MM/YYYY");        
        const colorTitulo = process.env.REACT_APP_COLOR        
        return (
        <span>
            <Box pl={1} my={1}>
                <Card  >
                <CardContent>
                    <Box display="flex" flexDirection="row" justifyContent="center">
                        <Encabezado espacio={{}} estiloCampo={{fontWeight: '800'}} descripcion={"NoEco"} 
                        campo={orden.NoEco}/>
                        <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '600'}}
                            descripcion={"Serie"} campo={orden.Serie}/>
                        
                        {/* <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '900'}}
                                    descripcion={"Sección"} campo={orden.seccNom}/> */}
                        <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '600'}}
                            descripcion={"Marca"} campo={orden.MarcaNom}/>      
                    <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '600'}}
                            descripcion={"Modelo"} campo={orden.ModelNom}/>  
                    </Box>
                    <Box display="flex" flexDirection="row" justifyContent="center">
                            
                                                   
                        
                        <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '600'}}
                            descripcion={"Tipo"} campo={orden.TpNom}/>    
                        <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '600'}}
                            descripcion={"Horometro"} campo={orden.Horometro}/>     
                        <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '600'}}
                            descripcion={"Combustible"} campo={orden.Combustible}/>      
                        <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '600'}}
                            descripcion={"Seguro"} campo={orden.SegNom}/>     
                    </Box>
                    {orden.UbicNom.length !== 0 && orden.UbicNom !== ' ' ?
                        <CampoRenglon estiloBox={{display: "flex"}} titulo="Ubicación" campo={orden.UbicNom}
                            estiloTitulo={{color: colorTitulo, fontWeight: 700, paddingRight: 0.2 + 'rem'}}
                        />
                        : null}    
                    {orden.Descr.length !== 0 && orden.Descr !== ' ' ?
                        <CampoRenglon estiloBox={{display: "flex"}} titulo="Descripción" campo={orden.Descr}
                            estiloTitulo={{color: colorTitulo, fontWeight: 700, paddingRight: 0.2 + 'rem'}}
                        />
                        : null}  
                    {orden.Notas.length !== 0 && orden.Notas !== ' ' ?
                        <CampoRenglon estiloBox={{display: "flex"}} titulo="Notas" campo={orden.Notas}
                            estiloTitulo={{color: colorTitulo, fontWeight: 700, paddingRight: 0.2 + 'rem'}}
                        />
                        : null}                    
                </CardContent>                     
                </Card>
            </Box>                    
            <RepoTab regisMaquinaria={regisMaquinaria}     />           
        </span>)
    }

    const funcionActuliza = () => {
        setBuscar(!buscar)
        setOpcionStatus(-1)
    }

    function handleAbrir() {
        setModalAbierto(true)
    }

    const onChangeCheck = (event) => {
        setFiltro({
          ...filtro,
            [event.target.name]: event.target.checked 
          });
    };

    const CardStatus=({tipo,indice})=>{
        //console.log(indice);
        
        const auxColor=tipo.Col
        const auxEstilo = indice>=4?{marginTop:".5rem"}:[]
        const estiloSelect= opcionStatus===tipo.Id ? {backgroundColor: auxColor, color: "white"}:{backgroundColor:"", color: auxColor}
        return<>
        <Grid item sx={3} style={{...auxEstilo,}}>
        <Card style={{...estiloSelect, padding:0, margin:0, minWidth:"8rem", marginLeft:"1rem", textAlign:"center"}} 
            onClick={()=>filtroStatus(tipo.Id)}>
            <CardContent style={{padding:0, margin:0, marginTop:".2rem", marginBottom:".2rem", fontSize:"13px", fontWeight:600}} > {tipo.Descr}</CardContent>
        </Card>  
        </Grid>
        {/* <Card style={{padding:0, margin:0, backgroundColor: opcionStatus===tipo.Id ? auxColor:"", color: opcionStatus===tipo.Id ? "white": auxColor, width:"12rem", marginLeft:"1rem",
            textAlign:"center" }} onClick={()=>setOpcionStatus(tipo.Id)}>
            <CardContent style={{padding:0, margin:0, marginTop:".2rem", marginBottom:".2rem"}} > 
                <Button  onClick={()=>setOpcionStatus(tipo.Id)} color="primary" size="small" style={{marginLeft:"1rem"}}> 
                    {tipo.Descr}
                </Button>  
            </CardContent>
        </Card> */}
        </>
    }

    const contenido = regisMaquinaria.length!=0 ?(costadoDerecho(regisMaquinaria)):(null)
    const principal = () => {        
        const verArr=listMaquinaria.length !==0 ? false:true
        const estiloSelect= opcionStatus===-1 ? {backgroundColor: "#F58634", color: "white"}:{backgroundColor:"", color: "#F58634"}
        const colSelect= listStatus.length!==0 && opcionStatus!=="-1" ?listStatus.filter((estado)=> estado.Id=== parseInt(opcionStatus)):[{Col:""}]
        //console.log(colSelect,listStatus,opcionStatus);
        
        return (
        <>
        <Grid container alignItems={'flex-start'} style={{marginTop: '.5rem', marginBottom: '.5rem'}}>
            <Grid item xs={12}>
                <Card className={classes.altura2}>
                    <CardContent style={{padding: '.5rem'}}>
                        <Box   display="flex" alignItems={'center'} flexDirection={"row"} >
                            
                            <Box  >
                                <Tooltip title="Actualizar">
                                <IconButton color="primary" size={"small"} onClick={funcionActuliza}
                                    style={{paddingTop: '.6rem'}}>
                                    <ReplayIcon/>
                                </IconButton>
                                </Tooltip>
                            </Box>                     
                            
                          
                            <TextField id="outlined-basic" label="Filtrar por NoEco" variant="outlined" size="small" disabled={verArr}
                                name="filtroNoEco" value={filtroNoEco} onChange={onChange} style={{marginRight:"1rem", width:"12rem"}}/>
                            
                            
                            <TextField id="outlined-basic" label="Filtrar  por Serie" variant="outlined" size="small" disabled={verArr}
                                name="filtroSerie" value={filtroSerie} onChange={onChange2} style={{marginRight:"1rem", width:"12rem"}}/>
                        
                        
                            <TextField id="outlined-basic" label="Filtrar por Descripción" variant="outlined" size="small"   disabled={verArr}                         
                                name="filtroDescr" value={filtroDescr} onChange={onChange3}style={{width:"12rem", marginRight:"1rem"}} />
                            {opcionStatus !==-1 && opcionStatus !=="-1" ? 
                                <FiberManualRecordIcon size="small" style={{color: colSelect[0].Col, size:"30px" }} />  
                            :null}
                         {  <FormControl className={classes.formControl} size="small" style={{width:20+'rem'}}>
                                <InputLabel htmlFor="age-native-simple" style={{width:20+'rem'}} variant="outlined">Estatus</InputLabel>
                                <Select style={{width:20+'rem'}} 
                                    native variant="outlined"
                                    value={opcionStatus} label="Estatus"
                                    onChange={(e)=>filtroStatus(e.target.value)}                                               
                                    inputProps={{name: 'opcionStatus', id: 'opcionStatus'}}                            
                                >
                                    {/* <option aria-label="None" value="" />       */}
                                    <option aria-label="None" value={-1} > TODOS</option>
                                    {listStatus.map((row) => (
                                          
                                    <option value={row.Id} style={{color:row.Col}}> 
                                   
                                    {row.Descr}</option>
                                    
                                    ))}   
                                </Select>
                            </FormControl> }
                            
                           {/*  <Box display={"flex"} flexDirection={"column"} style={{maxWidth:"45rem", overflowX:"auto", overflowY:"hidden", }} ml={1}>
                                <Typography color="primary" style={{fontWeight:600}}>Estatus</Typography>
                                <Grid container>
                                    <Grid item sx={3}  >
                                    <Card style={{...estiloSelect, padding:0, margin:0, minWidth:"8rem", marginLeft:"1rem", textAlign:"center"}} 
                                        onClick={()=>filtroStatus(-1)}>
                                        <CardContent style={{padding:0, margin:0, marginTop:".2rem", marginBottom:".2rem", fontSize:"13px", fontWeight:600}} > TODOS</CardContent>
                                    </Card>  
                                    </Grid>
                                {listStatus.length!==0 ?
                                    listStatus.map(( status,index)=>{
                                        return<CardStatus tipo={status} indice={index} />
                                    })
                                    
                                :null}
                                </Grid>
                            </Box> */}
                            {/* <Box  style={{marginLeft:"1rem"}}>
                                {listMaquinaria.length !== 0 ?
                                    <FormControl className={classes.formControl} size="small" style={{width:"25rem"}}>
                                        <InputLabel htmlFor="terminal1-native-simple">Maquinaria</InputLabel>
                                        <MaterialSelect
                                            native value={terminal} onChange={onChangeTerminal}
                                            inputProps={{name: 'terminal', id: 'terminal'}}
                                        >
                                            <option aria-label="None" value=""/>
                                            {listMaquinaria.map((row) => (
                                                <option value={row.Id}>{row.Descr}</option>
                                            ))}
                                        </MaterialSelect>
                                    </FormControl>
                                : null}
                            </Box>   */}                       
                            {/* <Grid item>
                                <TextField id="outlined-basic" label="Folio" variant="outlined" size="small"
                                    name="orden" value={orden} onChange={onChange}/>
                            </Grid> */}
                    </Box>
                </CardContent>
            </Card>
            </Grid>
        </Grid>

        <Box  display={"flex"} flexDirection={"row"} alignItems={'flex-start'} >
            <Box width={"40rem"}  >
                {espera ? 
                    (<Box mt={5} ml={2}><LinearProgress/> </Box>) 
                :   <TablaOrden 
                        setListBit={setListBit}   
                        listMaquinaria={listMaquinaria}
                        registro={regisMaquinaria} 
                        setRegistro={setRegistroMaquinaria}
                        setEsperaTabBit={setEsperaTabBit}
                        filtroSerie={filtroSerie}
                        filtroNoEco={filtroNoEco}
                        filtroDescr={filtroDescr}
                    />
                }
            </Box >
            <Box width={"52rem"}    style={{paddingLeft:".5rem"}}>
                {contenido}
               {/* regisMaquinaria.length!==0? <RepoTab regisMaquinaria={regisMaquinaria}     /> :null */}
                
                {/* esperaTabBit ? (<Box><LinearProgress/> </Box>) :
                (    listBit.length!==0?
                        <TablaBitacora listBit={listBit}  regisMaquinaria={regisMaquinaria} funcionActuliza={getListTabla} />
                        :null) */
                }
            </Box >
        </Box >
        </>
        )
    }

 
    return (
    <>
        {principal()}
        
    </>
    )
}

export default Bitacora